import React, { type FC, useState } from 'react'
import { Box, Chip, type ChipProps, Typography as MuiTypography, type TypographyProps } from '@mui/material'

const typographyVariants = [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'caption',
    // 'button',
    // 'overline',
    // 'code1',
    // 'code2',
] as const satisfies readonly TypographyProps['variant'][]

const fontWeights = [300, 400, 500, 600, 700]

export const Typography: FC = () => {
    const [weight, setWeight] = useState<number>(400)

    return (
        <>
            {/* Typography */}
            <Box sx={{ my: 2 }}>
                {fontWeights.map((w) => {
                    const variant: ChipProps['variant'] = w === weight ? 'primary' : 'neutral'
                    return <Chip key={w} label={w} onClick={() => setWeight(w)} variant={variant} sx={{ mr: 1 }} />
                })}
            </Box>
            {typographyVariants.map((variant) => (
                <MuiTypography key={variant} variant={variant} fontWeight={weight} sx={{ display: 'block', mb: 2 }}>
                    Typography - {variant}
                </MuiTypography>
            ))}
        </>
    )
}
